import { InvestorCompanyDetailsOutputDto } from 'src/app/core/data-models/investor.data.models';
import { ErrorResponse } from '../../shared-data-models';
import { InvestorCompanyDataService } from './../../../core/data-services/company/investor-company-data.service';
import { Component, Input, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-investor-company-details',
  templateUrl: './investor-company-details.component.html',
  styleUrls: ['./investor-company-details.component.css']
})
export class InvestorCompanyDetailsComponent implements OnInit {
  @Input() investorId?: string;
  @Input() requestId?: string;
  details!: InvestorCompanyDetailsOutputDto;
  constructor(
    private investorCompanyDataService: InvestorCompanyDataService,
    private notificationService: NotificationService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.investorCompanyDataService.InvestorCompanyDetails(this.investorId, this.requestId).subscribe({
      next: (res) => {
        if (res && res.resource) {
          this.details = res.resource;
        }
      },
      error: (err: ErrorResponse) => {
        this.notificationService.error('Something went wrong!')
      }
    })
  }
  openFile(url:string){
    window.open(url, '_blank');
  }

}
